import { Box, Container, Grid, Skeleton, Typography } from "@mui/material"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useApi } from "auth/useApi"
import BodyRichContent from "components/Fields/BodyRichContent"
import PaperBox from "components/PaperBox"
import { TinyMCEViewer } from "components/TinyMCE/TinyMCEViewer"
import theme from "css/theme/light"
import { apiEndpoints } from "generated/apiEndpoints"
import DocumentsComponent from "pages/crisismanagement/components/DoucmentsComponent"
import PhoneContactsComponent from "pages/crisismanagement/components/PhoneContactsComponent"
import React, { useEffect, useRef, useContext } from "react"
import "./style.css"
import { AppContext } from "components/AppContextProvider"
import { isJson } from "components/TinyMCE/helpers"
import SosButton from "pages/crisismanagement/components/SosButton/SosButton"
import { useTranslation } from "react-i18next"

const CrisisInfo = () => {
  const { currentCompanyId } = useContext(AppContext)
  const [crisisInfoResult, crisisInfoApi] = useApi() as [IApiResult, IApiFunc]
  const editorRef = useRef<any | null>(null)
  const { t } = useTranslation()

  useEffect(() => {
    const crisisInfoUrl = apiEndpoints.crisismanagement.getcrisisinfobycompanyid.replace("{companyId}", currentCompanyId)
    crisisInfoApi.get(crisisInfoUrl)
  }, [crisisInfoApi, currentCompanyId])

  return (
    <div>
      <Container>
        <Grid container direction={"row"} padding={3} spacing={3}>
          <Grid item md={7} xs={12}>
            <Box>
              {crisisInfoResult.status === 2 ? (
                <>
                  <Typography variant="h3" mb={1}>
                    {crisisInfoResult.data.title}
                  </Typography>
                  <Typography variant="h5" color="textSecondary">
                    {crisisInfoResult.data.subTitle}
                  </Typography>
                </>
              ) : crisisInfoResult.status === 3 ? (
                <></>
              ) : (
                <>
                  <Skeleton variant="text" width={400} sx={{ fontSize: "2em" }} />
                  <Skeleton variant="text" width={300} sx={{ fontSize: "1em" }} />
                </>
              )}
            </Box>
            <SosButton className="show-mobile" sx={{ marginTop: 4 }} />
            <Box marginTop={4} marginBottom={4} className="show-mobile">
              {crisisInfoResult.status === 2 ? (
                <PhoneContactsComponent
                  managerData={crisisInfoResult.data.managerContactInfo}
                  otherData={crisisInfoResult.data.otherContactInfos}
                />
              ) : null}
            </Box>
            <PaperBox>
              {crisisInfoResult.status === 2 ? (
                isJson(crisisInfoResult.data.body) ? (
                  <BodyRichContent
                    content={crisisInfoResult.data.body}
                  />
                ) : (
                  <TinyMCEViewer
                    initVal={crisisInfoResult.data.body}
                    editorRef={editorRef}
                  />
                )
              ) : crisisInfoResult.status === 3 ? (
                <Typography variant="h4">{t("crisismanagement.no_crisis_information_found", "No crisis information found")}</Typography>
              ) : (
                <>
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <br />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <br />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <br />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <br />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <Skeleton variant="text" sx={{ fontSize: "1em" }} />
                  <br />
                </>
              )}
            </PaperBox>
          </Grid>
          <Grid item md={5} xs={12}>
            <PaperBox
              sx={{ backgroundColor: theme.palette.error["light"], marginTop: 0 }}
              className="dont-show-mobile">
              <Typography variant="h3" color={"error"}>
                {t("crisismanagement.alert_sos", "Alert SOS")}
              </Typography>
              <Typography mt={1}>{t("crisismanagement.you_have_a_accident", "You have an accident with personal injuries")}</Typography>
              <SosButton sx={{ marginTop: 3, marginBottom: 1 }} />
            </PaperBox>
            <Box marginTop={5} className="dont-show-mobile">
              {crisisInfoResult.status === 2 ? (
                <PhoneContactsComponent
                  managerData={crisisInfoResult.data.managerContactInfo}
                  otherData={crisisInfoResult.data.otherContactInfos}
                />
              ) : crisisInfoResult.status === 3 ? (
                <></>
              ) : (
                <>
                  <Skeleton variant="text" width={200} sx={{ fontSize: "1.5em" }} />
                  <Skeleton variant="rounded" height={55} sx={{ fontSize: "1.5em" }} />
                  <Skeleton variant="text" width={200} sx={{ fontSize: "1.5em", marginTop: 1 }} />
                  <Skeleton variant="rounded" height={55} sx={{ fontSize: "1.5em", marginBottom: 0.25 }} />
                  <Skeleton variant="rounded" height={55} sx={{ fontSize: "1.5em", marginBottom: 0.25 }} />
                  <Skeleton variant="rounded" height={55} sx={{ fontSize: "1.5em", marginBottom: 0.25 }} />
                </>
              )}
            </Box>
          </Grid>
          {crisisInfoResult.status === 3 ? (
            <></>
          ) : crisisInfoResult.status === 2 && crisisInfoResult.data.attachments ? (
            <DocumentsComponent attachments={crisisInfoResult.data.attachments} />
          ) : null}
        </Grid>
      </Container>
    </div>
  )
}
export default CrisisInfo
